export const CollapseIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.6339 11.7691C10.1457 11.281 9.35427 11.281 8.86612 11.7691L6.21967 14.4156C5.92678 14.7085 5.92678 15.1833 6.21967 15.4762C6.51256 15.7691 6.98744 15.7691 7.28033 15.4762L9.75 13.0066L12.2197 15.4762C12.5126 15.7691 12.9874 15.7691 13.2803 15.4762C13.5732 15.1833 13.5732 14.7085 13.2803 14.4156L10.6339 11.7691Z"
        fill="currentColor"
      />
      <path
        d="M13.2803 5.58306L10.6339 8.22951C10.1457 8.71767 9.35427 8.71767 8.86612 8.22951L6.21967 5.58306C5.92678 5.29017 5.92678 4.8153 6.21967 4.5224C6.51256 4.22951 6.98744 4.22951 7.28033 4.5224L9.75 6.99207L12.2197 4.5224C12.5126 4.22951 12.9874 4.22951 13.2803 4.5224C13.5732 4.8153 13.5732 5.29017 13.2803 5.58306Z"
        fill="currentColor"
      />
    </svg>
  );
};
